export const role = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    role: { en: 'Role', ko: '권한', fr: '' },
    name: { en: 'Name', ko: '이름', fr: '' },
    targetSystem: { en: 'Target System', ko: 'Target System', fr: '' },
    description: { en: 'description', ko: '설명', fr: '' },
  },
  info: {
    roleName: { en: 'Role name', ko: 'Role 이름', fr: '' },
    description: { en: 'Description', ko: '설명', fr: '' },
    targetSystem: { en: 'Target system', ko: 'Target System', fr: '' },
    function: { en: 'Function', ko: '기능', fr: '' },
    menu: { en: 'Menu', ko: '메뉴', fr: '' },
    resource: { en: 'Resource', ko: '리소스', fr: '' },
  },
  select: {
    targetSystem: { en: 'Select Target System', ko: 'Target System 선택', fr: '' },
  },
};
